import React, {Component} from 'react';
import "./style.scss"
import BigNumber from 'bignumber.js';
import Btn from './components/btn';
// import 'antd/dist/antd.css';

const STATUS_NUM1 = Symbol('S_NUM1')
const STATUS_NUM2 = Symbol('S_NUM2')
const STATUS_SYMBOL = Symbol('S_SYMBOL')
const STATUS_EQ = Symbol('S_EQ')

const ACTION_CONTROL = Symbol('A_CONTROL')

const ACTION_NUM = Symbol('A_NUM')
const ACTION_SYMBOL = Symbol('A_SYMBOL')
const ACTION_EQ = Symbol('A_EQ')


/*
11+22=    44+55=     ->99
1+2+3==              ->9
1+2=  +3=            ->6
1+2=  +3=  9=        ->12
2+3=  6=  9=         ->12
3+=  =  =            ->12
3==                   ->3
1=+3=                 ->4
9/===                 ->0.012345679012346
1+-3=                 ->-2
1..0 + ..2            ->1.2
8/9*9=                ->8
*/

/*
    1表示该变量有值，0表示无值  ?表示可有可无
    状态           result  num2	symbol	num1
    STATUS_NUM1	    0	   0	  0	    1
    STATUS_SYMBOL	0	   0	  1	    1
    STATUS_NUM2     0	   1	  1	    1
    STATUS_EQ       1	   1	  ?	    0       输入数字后，直接按等号，只时没有符号

    该状态LCD显示	输入后状态跳转
    状态            display	    0-9.	      + - * / 	    =
    STATUS_NUM1	    number1	    STATUS_NUM1	  STATUS_SYMBOL	STATUS_EQ
    STATUS_SYMBOL	number1	    STATUS_NUM2	  STATUS_SYMBOL	STATUS_EQ
    STATUS_NUM2	    number2	    STATUS_NUM2	  STATUS_EQ    	STATUS_EQ
    STATUS_EQ       result      STATUS_NUM1   STATUS_SYMBOL STATUS_EQ
*/

let defaultState = {
    state: STATUS_NUM1,
    num1: '',
    num2: '',
    symbol: '',
    result: '',
    display: '0',
}

let calculator = {
    ...defaultState,

    //添加"小数点"的逻辑
    appendDot(val) {
        if (val === '') {
            return '0.'
        }
        if (val === '0') {
            return '0.'
        }

        if (val.indexOf('.') === -1) {
            return val + '.'
        }

        return val
    },

    //运算
    operation: function () {
        let a = new BigNumber(this.num1)
        let b = new BigNumber(this.num2)

        switch (this.symbol) {
            case "+":
                this.result = a.plus(b).toString()
                break
            case "-":
                this.result = a.minus(b).toString()
                break
            case "*":
                this.result = a.multipliedBy(b).toString()
                break
            case "/":
                this.result = a.div(b).toString()
                break
            default:
                this.result = "ERROR"
                break
        }
    },

    // 状态转换
    transition: function (action, val) {

        if (action === ACTION_CONTROL) {
            switch (val) {
                case 'C':
                    for (let k in defaultState) {
                        this[k] = defaultState[k]
                    }
                    break
            }

            return
        }

        switch (this.state) {
            case STATUS_NUM1:
                switch (action) {
                    case ACTION_NUM:
                        this.state = STATUS_NUM1
                        if (val === '.') {
                            this.display = this.appendDot(this.display)
                        } else {
                            this.display = this.display === '0' ? val : (this.display + val)
                        }
                        break
                    case ACTION_SYMBOL:
                        this.state = STATUS_SYMBOL
                        this.num1 = this.display
                        this.symbol = val
                        break
                    case ACTION_EQ:
                        this.state = STATUS_EQ
                        // this.num2 = this.num1
                        // this.result = this.num1
                        // this.num1 = ''
                        // this.display = this.result

                        if (this.num2 !== '') {
                            this.num1 = this.display
                            this.operation()
                            this.display = this.result
                            this.num1 = ''
                        }

                        break
                    default:
                        this.display = 'ERROR'
                }
                break
            case STATUS_SYMBOL:
                switch (action) {
                    case ACTION_NUM:
                        this.state = STATUS_NUM2

                        if (val === '.') {
                            this.display = this.appendDot('0')
                        } else {
                            this.display = val
                        }

                        break

                    case ACTION_SYMBOL:
                        this.state = STATUS_SYMBOL
                        this.symbol = val
                        break
                    case ACTION_EQ:
                        this.state = STATUS_EQ
                        this.num2 = this.num1
                        this.operation()
                        this.num1 = ''
                        this.display = this.result
                        break
                    default:
                        this.display = 'ERROR'
                }


                break;

            case STATUS_NUM2:
                switch (action) {
                    case ACTION_NUM:
                        if (val === '.') {
                            this.display = this.appendDot(this.display)
                        } else {
                            this.display = this.display === '0' ? val : (this.display + val)
                        }
                        break
                    case ACTION_SYMBOL:
                        this.state = STATUS_SYMBOL
                        this.num2 = this.display
                        this.operation()
                        this.num1 = this.result
                        this.num2 = ''
                        this.symbol = val
                        this.display = this.result
                        break
                    case ACTION_EQ:
                        this.num2 = this.display
                        this.state = STATUS_EQ
                        this.operation()
                        this.num1 = ''
                        this.display = this.result
                        break
                    default:
                        this.display = 'ERROR'
                }

                break;
            case STATUS_EQ:
                switch (action) {
                    case ACTION_NUM:
                        this.state = STATUS_NUM1
                        if (val === '.') {
                            this.display = this.appendDot('0')
                        } else {
                            this.display = val
                        }
                        break
                    case ACTION_SYMBOL:
                        this.state = STATUS_SYMBOL
                        this.symbol = val
                        this.num1 = this.display
                        this.num2 = ''
                        break
                    case ACTION_EQ:

                        if (this.symbol !== '') {
                            this.num1 = this.result
                            this.operation()
                            this.num1 = ''
                            this.display = this.result
                        }

                        break
                    default:
                        this.display = 'ERROR'
                }

                break;

            default:
                this.display = 'ERROR'
                break;
        }
    }

}

let buttons = [

    {name: 'C', action: ACTION_CONTROL},
    {name: '', action: ACTION_CONTROL}, //+/-
    {name: '', action: ACTION_CONTROL}, //<-
    {name: '/', action: ACTION_SYMBOL},

    {name: '7', action: ACTION_NUM},
    {name: '8', action: ACTION_NUM},
    {name: '9', action: ACTION_NUM},
    {name: '*', action: ACTION_SYMBOL},

    {name: '4', action: ACTION_NUM},
    {name: '5', action: ACTION_NUM},
    {name: '6', action: ACTION_NUM},
    {name: '-', action: ACTION_SYMBOL},

    {name: '1', action: ACTION_NUM},
    {name: '2', action: ACTION_NUM},
    {name: '3', action: ACTION_NUM},
    {name: '+', action: ACTION_SYMBOL},


    {name: '0', action: ACTION_NUM},
    {name: '.', action: ACTION_NUM},
    {name: '=', action: ACTION_EQ},
]

class Calculator extends Component {

    constructor(props) {
        super(props)
        this.state = calculator
    }

    handleClick(item) {
        console.log(item)
        calculator.transition(item.action, item.name)
        this.setState({
            display: calculator.display
        })
        console.log(calculator)
    }

    render() {
        return (
            <div className={'Calculator'}>
                <div className={'display'}>{this.state.display}</div>

                <div className={'btns'}>
                    {buttons.map((item) => {
                        return (
                            <Btn item={item} key={item.name} handleClick={() => {
                                this.handleClick(item)
                            }}/>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default Calculator